import axios from 'axios';

const settings = window.APP_SETTINGS;

export const validateInvitationToken = token => {
    return axios.post(
        `${settings.EXPERT_API_BASE_URL}/account/validate-invitation-token`,
        { token }
    );
};

export const validateResetToken = token => {
    return axios.post(
        `${settings.EXPERT_API_BASE_URL}/account/validate-reset-password-token`,
        { token }
    );
};

export const createUser = (
    userName,
    password,
    confirmPassword,
    token
) => {
    const userCredentials = {
        password,
        confirmPassword,
        invitationToken: token
    };

    return axios.post(`${settings.EXPERT_API_BASE_URL}/account/${userName}/credentials`, userCredentials);
};

export const sendResetPasswordEmail = email => {
    return axios.post(`${settings.EXPERT_API_BASE_URL}/account/${email}/reset-password-email`, {});
};

export const resetPassword = (password, confirmPassword, token) => {
    const params = {
        password,
        confirmPassword,
        token
    };

    return axios.post(`${settings.EXPERT_API_BASE_URL}/account/password-reset`, params);
};
